var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDashCardBar(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 186,
    height: 7,
    viewBox: "0 0 186 7",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.53076 0.5H181.638C183.295 0.5 184.638 1.84315 184.638 3.5C184.638 5.15685 183.295 6.5 181.638 6.5H3.53076C1.87391 6.5 0.530762 5.15685 0.530762 3.5C0.530762 1.84315 1.87391 0.5 3.53076 0.5Z",
    stroke: "#18E97F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.0307617 3.5C0.0307617 1.567 1.59777 0 3.53076 0H140.404V7H3.53076C1.59776 7 0.0307617 5.433 0.0307617 3.5V3.5Z",
    fill: "#18E97F"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashCardBar);
export default __webpack_public_path__ + "static/media/dash-card-bar.b31fb1953a7204890346f86bcb283c95.svg";
export { ForwardRef as ReactComponent };